import { useNostr } from '@nostrify/react';
import { useQuery } from '@tanstack/react-query';
import { VideoCard } from './VideoCard';
import { Skeleton } from './ui/skeleton';
import { useCurrentUser } from '@/hooks/useCurrentUser';

export function VideoFeed() {
  const { nostr } = useNostr();
  const { user } = useCurrentUser();

  const { data: videos, isLoading, error } = useQuery({
    queryKey: ['video-feed'],
    queryFn: async ({ signal }) => {
      const events = await nostr.query(
        [{ kinds: [21], limit: 50 }],
        { signal }
      );
      return events.sort((a, b) => b.created_at - a.created_at);
    },
  });

  if (isLoading) {
    return (
      <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 xl:grid-cols-4 gap-6">
        {Array.from({ length: 8 }).map((_, i) => (
          <div key={i} className="space-y-3">
            <Skeleton className="h-48 w-full rounded-lg" />
            <Skeleton className="h-4 w-3/4" />
            <Skeleton className="h-3 w-1/2" />
          </div>
        ))}
      </div>
    );
  }

  if (error) {
    return (
      <div className="text-center py-12">
        <p className="text-destructive">Failed to load videos. Please check your relay connections.</p>
      </div>
    );
  }

  if (!videos || videos.length === 0) {
    return (
      <div className="text-center py-12">
        <div className="max-w-sm mx-auto space-y-4">
          <div className="text-6xl mb-4">🎬</div>
          <h2 className="text-2xl font-semibold">No videos yet</h2>
          <p className="text-muted-foreground">
            Be the first to bookmark a video! Click the "Add Bookmark" button to get started.
          </p>
        </div>
      </div>
    );
  }

  return (
    <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 xl:grid-cols-4 gap-6">
      {videos.map((event) => (
        <VideoCard key={event.id} event={event} />
      ))}
    </div>
  );
}